<template>
  <div id="app">
    <router-view />
    <fixed-menu/>
  </div>
</template>

<script>
import FixedMenu from './components/FixedMenu.vue';
export default {
  components: { FixedMenu },
  name: "App",
  created() {
    if (this._isMobile()) {
      location.href = 'https://chrivc.com/mobile/#/'
    }
  },
  methods: {
    _isMobile() {
      let flag = false;
      const sUserAgent = navigator.userAgent.toLowerCase();
      const bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
      const bIsIphone = sUserAgent.match(/iphone os/i) == "iphone os";
      const bIsMidp = sUserAgent.match(/midp/i) == "midp";
      const bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
      const bIsUc = sUserAgent.match(/ucweb/i) == "web";
      const bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
      const bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
      const bIsAndroid = sUserAgent.match(/android/i) == "android";
      if (
        bIsIpad ||
        bIsIphone ||
        bIsMidp ||
        bIsUc7 ||
        bIsUc ||
        bIsCE ||
        bIsWM ||
        bIsAndroid
      ) {
        flag = true;
      } else {
        flag = false;
      }
      return flag;
    }
  }
};
</script>

<style lang="scss">
#app {
  overflow: hidden;
}
* {
  padding: 0;
  margin: 0;
  font-family: PingFang SC;
}
.container {
  width: 1200px;
  margin: 0 auto;
}

.filter-box{
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  .filter-item{
    margin-right: 20px;
  }
  input[round] {
    border-radius: 25px;
  }
  .el-select[round]{
    input{
      border-radius: 25px;
    }
  }
  .el-date-editor[round] {
    border-radius: 25px;
    input{
      border-radius: 25px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue